import Header from './header';

export default class HeaderDesktop extends Header {
	constructor(...args) {
		super(...args);
	}

	_animate(){

		this.dom.images[this.params.next].classList.remove('first-show');
		this.dom.lettersNext = this.dom.title[this.params.next].querySelectorAll('.title-slide > .word > .letter');
		this.dom.lettersCurrent = this.dom.title[this.params.current].querySelectorAll('.title-slide > .word > .letter');

		// animation bullets
		this.dom.bullets[this.params.current].classList.remove('active');
		this.dom.bullets[this.params.next].classList.add('active');

		// update attribut
		this.dom.itemSlide.setAttribute("data-current", this.params.next);


		this.anim
			.fromTo(this.dom.button[this.params.current], 1, { autoAlpha: 1 }, { autoAlpha: 0, force3D:true, ease: Expo.easeInOut}, 0 )
			.fromTo(this.dom.subtitle[this.params.current], 1.4, {y: 0, autoAlpha: 1}, {y: -40, autoAlpha: 0, force3D:true, ease: Expo.easeInOut}, 0 )
			.staggerFromTo(this.dom.lettersCurrent, 1, {y: 0, autoAlpha: 1, ease: Expo.easeInOut}, {y: -30, autoAlpha: 0, ease: Expo.easeInOut}, 0.1, 0.1)
			.to(this.dom.lettersCurrent, 0, {y:0})
			.fromTo(this.dom.images[this.params.next], 1.4, {x: "100%", zIndex: 5}, {x: '0%', force3D:true, ease: Expo.easeInOut}, 0.1 )
			.to(this.dom.images[this.params.current], 0, {zIndex: 1})
			.to(this.dom.button[this.params.current], 0, {autoAlpha: 0})
			.add(() => {
				this.dom.contentText[this.params.current].style.display = 'none';
				this.dom.contentText[this.params.next].style.display = 'block';
			})
			.to(this.dom.images[this.params.next], 0, {zIndex: 3})
			// .to(this.dom.button[this.params.next],0, {autoAlpha: 1})
			.staggerFromTo(this.dom.lettersNext, 1.2, {x: 14, autoAlpha: 0, ease: Expo.easeInOut}, {x: 0, autoAlpha: 1, ease: Expo.easeInOut}, 0.1, 1.2)
			.fromTo(this.dom.subtitle[this.params.next], 1.3, {y: -30, autoAlpha: 0}, {y: 0, autoAlpha: 1, ease: Expo.easeInOut}, 1.6)
			.fromTo(this.dom.button[this.params.next], 1.4, { autoAlpha: 0 }, { autoAlpha: 1, ease: Expo.easeInOut}, 1.9 )

	}

	/*
	init() {
	}
	bind() {
	}
	unbind() {
	}
	resize(width, height) {
	}
	*/
}



// WEBPACK FOOTER //
// ./src/js/components/header/header.desktop.js